import React from 'react';
import { Card } from '../components/ui/card';

function TermsPage() {
  return (
    <div className="min-h-screen py-8 px-4">
      <div className="container mx-auto max-w-4xl">
        <h1 className="text-3xl font-display font-normal mb-8">Terms and Conditions</h1>
        
        <Card className="p-6 space-y-6">
          <p className="text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>

          <section>
            <h2 className="text-xl font-semibold mb-3">Agreement to Terms</h2>
            <p className="text-muted-foreground">
              By accessing and using the Mothering website, you accept and agree to be bound by these Terms and Conditions. 
              If you do not agree, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Eligibility</h2>
            <p className="text-muted-foreground">
              You must be at least 18 years old to make purchases on our website. By placing an order, you confirm that 
              you are of legal age and have the authority to enter into this agreement.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Product Information</h2>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li>We strive to provide accurate product descriptions and images</li>
              <li>Actual colors may vary slightly due to screen settings</li>
              <li>We reserve the right to update product information without notice</li>
              <li>Products are subject to availability</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Pricing and Payment</h2>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li>All prices are in Indian Rupees (₹) and include applicable taxes</li>
              <li>Free delivery is included on all orders</li>
              <li>We reserve the right to modify prices without prior notice</li>
              <li>Payment must be made in full before order dispatch</li>
              <li>We only accept prepaid orders (no Cash on Delivery)</li>
              <li>All payments are processed through Razorpay</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Order Acceptance</h2>
            <p className="text-muted-foreground">
              We reserve the right to refuse or cancel any order at our discretion. Reasons may include product 
              unavailability, pricing errors, suspected fraud, or other issues identified by our team.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Shipping and Delivery</h2>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li>Delivery timelines are estimates and not guaranteed</li>
              <li>We are not responsible for delays caused by courier partners or unforeseen circumstances</li>
              <li>Customers must provide accurate delivery addresses</li>
              <li>Risk of loss passes to you upon delivery</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Returns and Refunds</h2>
            <p className="text-muted-foreground">
              Our returns and refunds are governed by our Returns Policy. Please review the policy before making a purchase.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Intellectual Property</h2>
            <p className="text-muted-foreground">
              All content on this website, including images, text, logos, and designs, is the property of F Square Media 
              (operating as Mothering) and protected by copyright laws. Unauthorized use is prohibited.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">User Conduct</h2>
            <p className="text-muted-foreground mb-2">You agree not to:</p>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li>Use the website for any unlawful purpose</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Upload malicious code or viruses</li>
              <li>Interfere with other users' experience</li>
              <li>Scrape or copy our content without permission</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Limitation of Liability</h2>
            <p className="text-muted-foreground">
              To the maximum extent permitted by law, Mothering (F Square Media) shall not be liable for any indirect, incidental, 
              special, or consequential damages arising from your use of our website or products.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Disclaimer</h2>
            <p className="text-muted-foreground">
              Our products are provided "as is" without any warranties, express or implied. We do not guarantee that 
              our website will be uninterrupted, secure, or error-free.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Governing Law</h2>
            <p className="text-muted-foreground">
              These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction 
              of courts in New Delhi, India.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Changes to Terms</h2>
            <p className="text-muted-foreground">
              We reserve the right to modify these terms at any time. Continued use of our website after changes 
              constitutes acceptance of the new terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Contact Us</h2>
            <p className="text-muted-foreground">
              For questions about these terms, contact us at:
            </p>
            <ul className="list-none space-y-1 text-muted-foreground mt-2">
              <li><strong>F Square Media</strong></li>
              <li>Address: Panchsheel Park, New Delhi - 110017</li>
              <li>Email: motheringin@gmail.com</li>
              <li>Phone/WhatsApp: +91 88103 45965</li>
            </ul>
          </section>
        </Card>
      </div>
    </div>
  );
}

export default TermsPage;